import { OverlayScrollbars } from "overlayscrollbars";

export default class CustomScroll {
  constructor(node) {
    this.element = node;
    this.scrollElement = this.element.querySelector(".js-scroll-container");

    this.initialize();
  }

  initialize() {
    OverlayScrollbars(this.scrollElement, {});
  }
}
